export default __webpack_public_path__ + "3d4b6d319990ec78bf9a2c19863a719d.png";